import i18n from '@/utils/i18n';
import React from 'react';
import { ORDER_INBOUNDS_ROUTES } from '@/navigators/routes';
import { OrderInboundsStackParams } from '@/navigators/types';
import { PageContainer } from '@/components/page-container';
import { StackScreenProps } from '@react-navigation/stack';
import { StyleSheet, View } from 'react-native';
import { SwapInboundItemSearchContent } from './swap-item-search-content';
import { useItemDetailContext } from '@/contexts/item-detail-context';
import { useOrderInboundsStore } from '@/stores/order-inbounds-store';

type Props = StackScreenProps<
  OrderInboundsStackParams,
  ORDER_INBOUNDS_ROUTES.SwapSearch
>;

export const SwapItemSearchScreen: React.FC<Props> = ({
  route,
  navigation,
}) => {
  const { closeDetailSheet } = useItemDetailContext();

  const isSwapInProgress = useOrderInboundsStore(
    (state) => state.isSwapInProgress,
  );

  const alternativeMatches = route.params.alternativeMatches;
  const previousMatches = route.params.previousMatches;
  const savedVariantPackOrderCountsMap =
    route.params.savedVariantPackOrderCountsMap;
  return (
    <PageContainer
      navigationHeaderProps={{
        centerTitle: true,
        onBackPress: () => {
          if (isSwapInProgress) {
            return;
          }
          navigation.goBack();
        },
        showBackButton: true,
        showShadow: true,
        title: i18n.t('search'),
      }}
    >
      <View style={styles.container}>
        <SwapInboundItemSearchContent
          alternativeMatches={alternativeMatches}
          initialRememberSelection={Boolean(
            route.params.initialRememberSelection,
          )}
          onSetRememberSelection={route.params.onSetRememberSelection}
          onSwapItem={async (metadata, rememberSelection) => {
            await route.params.selectItem?.(metadata, rememberSelection);
            closeDetailSheet();
          }}
          previousMatches={previousMatches}
          savedVariantPackOrderCountsMap={savedVariantPackOrderCountsMap}
          variantPackUUID={route.params.initialVariantPackUUID}
        />
      </View>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 16,
  },
});
